import styled, { css } from "styled-components";
import { ButtonProps } from "./Button.types";
import { pxToRem } from "../../../styles/utils";

export const StyledButton = styled.button<ButtonProps>`
  width: ${({ width }) => width || "100%"};

  min-width: ${pxToRem(100)};
  max-width: ${pxToRem(300)};
  
  height: ${({ height }) => height || pxToRem(50)};
  padding: ${pxToRem(10)} ${pxToRem(20)};
  font-size: ${pxToRem(16)};
  font-weight: bold;
  border-radius: ${pxToRem(12)};
  color: rgb(255, 255, 255);
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  transition: all 0.3s ease;
  border: none;
  // margin: ${pxToRem(8)};

  ${({ variant, disabled, isStaticOnHover }) => {
    if (disabled && variant !== "flatNotFilled") {
      return css`
        box-shadow: inset 0px ${pxToRem(-2)} 0px 0px rgb(93, 68, 176);
        background: rgb(114, 82, 220);
        opacity: 0.3;
      `;
    }

    const hoverEffect = isStaticOnHover
      ? ""
      : css`
          &:hover {
            transform: translateY(${pxToRem(-3)});
          }
        `;

    switch (variant) {
      case "active":
        return css`
          box-shadow: inset 0px ${pxToRem(-2)} 0px 0px rgb(93, 68, 176),
            0px ${pxToRem(7)} ${pxToRem(11)} 0px rgb(121, 90, 223);
          background: linear-gradient(
              180deg,
              rgba(189, 169, 255, 0.7),
              rgba(114, 82, 220, 0.5) 100%
            ),
            rgb(114, 82, 220);

          ${hoverEffect}
        `;
      case "flatNotFilled":
        return css`
          ${disabled
            ? css`
                border: ${pxToRem(1)} solid rgba(114, 82, 220, 0.3);
                color: rgba(114, 82, 220, 0.3);
                background: rgba(255, 255, 255, 0.5);
                cursor: not-allowed;
              `
            : css`
                border: ${pxToRem(1)} solid rgb(114, 82, 220);
                border-radius: ${pxToRem(12)};
                color: rgb(114, 82, 220);
                background: rgb(255, 255, 255);

                ${hoverEffect}
              `}
        `;
      case "flatFilled":
        return css`
          border-radius: ${pxToRem(12)};
          background: rgb(144, 112, 245);

          ${hoverEffect}
        `;
      case "backgroungNone":
        return css`
          border-radius: ${pxToRem(12)};
          background: none;
          border: ${pxToRem(1)} solid rgb(114, 82, 220);
          color: rgb(114, 82, 220);

          ${hoverEffect}
        `;

      case "red":
        return css`
          border-radius: ${pxToRem(12)};
          box-shadow: inset 0px ${pxToRem(-2)} 0px 0px rgb(234, 0, 4),
            0px ${pxToRem(7)} ${pxToRem(11)} 0px rgb(223, 90, 92);
          background: linear-gradient(
              180deg,
              rgba(255, 169, 170, 0.44),
              rgba(221, 0, 4, 0.5) 100%
            ),
            rgb(237, 0, 4);
          color: rgb(255, 255, 255);

          ${hoverEffect}
        `;
        
      case "pink":
        return css`
          border-radius: ${pxToRem(12)};
          box-shadow: inset 0px ${pxToRem(-2)} 0px 0px rgb(167, 1, 107),
            0px ${pxToRem(7)} ${pxToRem(11)} 0px rgb(185, 0, 118);
          background: linear-gradient(
              180deg,
              rgba(235, 0, 98, 0.44),
              rgba(211, 4, 90, 0.5) 100%
            ),
            rgb(218, 0, 185);
          color: rgb(255, 255, 255);

          ${hoverEffect}
        `;

      case "default":
        return css`
          box-shadow: inset 0px ${pxToRem(-2)} 0px 0px rgb(93, 68, 176),
            0px ${pxToRem(7)} ${pxToRem(11)} 0px rgb(121, 90, 223);
          background: linear-gradient(
              180deg,
              rgb(189, 169, 255),
              rgb(114, 82, 220) 100%
            ),
            rgb(114, 82, 220);

          ${hoverEffect}
        `;
      default:
        return "";
    }
  }};
`;
